import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 11.5V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M14 10V8a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 9.9V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 14v0a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 11v0a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Grab";
const Grab = memo(themed(Icon));
export {
  Grab
};
//# sourceMappingURL=grab.js.map
